import { HOW_IT_WORKS } from "../mock";
import { getIcon } from "../lib/icons";

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-20 lg:py-28 bg-[#f7faf9]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.18em] text-[#16d196]">
            <span className="w-1.5 h-1.5 rounded-full bg-[#16d196]" />
            How it works
          </div>
          <h2 className="mt-4 text-[36px] lg:text-[56px] font-extrabold leading-[1.05] tracking-[-0.025em] text-[#0d1a2e]">
            Four simple steps from{" "}
            <span className="text-[#16d196]">capital to compound.</span>
          </h2>
          <p className="mt-5 text-[#0d1a2e]/65 text-[16.5px] max-w-2xl leading-relaxed">
            We've cut every ounce of paperwork. Most investors are matched, vetted and
            subscribed within 14 days — we do the heavy lifting.
          </p>
        </div>

        <div className="mt-12 lg:mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {HOW_IT_WORKS.map((s) => {
            const Icon = getIcon(s.icon);
            return (
              <div
                key={s.step}
                className="relative bg-white border border-[#0d1a2e]/10 rounded-2xl p-6 hover:border-[#16d196]/60 hover:shadow-[0_12px_36px_rgba(13,26,46,0.06)] transition-all"
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-xl bg-[#0d1a2e] flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#16d196]" strokeWidth={2.2} />
                  </div>
                  <span className="inline-flex items-center text-[10px] font-bold uppercase tracking-[0.14em] text-[#16d196] bg-[#0d1a2e] rounded-full px-2.5 py-1">
                    Step {s.step}
                  </span>
                </div>
                <h3 className="mt-5 text-[19px] font-extrabold text-[#0d1a2e] tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-2 text-[14px] text-[#0d1a2e]/60 leading-relaxed">
                  {s.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
